import { useDroppable } from '@dnd-kit/core';

// A plain useDroppable(...) call only reaches the REAL DndContext when the
// component calling it is a genuine React-tree DESCENDANT of <DndContext> -
// calling it directly in the SAME component that renders <DndContext> as
// part of its own return value sees dnd-kit's DEFAULT context instead
// (dispatch: noop), which silently no-ops registration: no error, no
// missing ref, `setNodeRef` still attaches to a real DOM node, but the
// droppable never actually enters collision detection. This was a real bug
// (a top-level "end of list" dropzone that never registered) - this tiny
// wrapper exists so a plain droppable region can be dropped directly into a
// DndContext-owning component's own JSX without hand-rolling a child
// component every time just to get real descendant placement.
export default function DroppableRegion({ id, className, overClassName, children }) {
   const { setNodeRef, isOver } = useDroppable({ id });
   return (
      <div ref={setNodeRef} className={className + (isOver && overClassName ? ' ' + overClassName : '')}>
         {children}
      </div>
   );
}
